import { createSlice } from '@reduxjs/toolkit';
import { EaseBuzzIcon } from 'utils/icons';

export const userSlice = createSlice({
  name: 'user',
  initialState: {
    isLoggedIn: false,
    currentUser: {},
    planModal: false,
    plan: {},
    theme: {
      colorPrimary: '#6D44E5',
      colorFillAlter: '#580d0d00',
      logo: <EaseBuzzIcon />
    },
    planPermissions: {},
    extraParam: {},
    rmDetails: {},
    navigationTourGuidetails: {},
    productList: {}
  },
  reducers: {
    updateCurrentUser: (state, action) => {
      return {
        ...state,
        currentUser: { ...action.payload }
      };
    },
    updateIsLoggedIn: (state, action) => {
      return {
        ...state,
        isLoggedIn: action.payload
      };
    },
    updatePlanModal: (state, action) => {
      return {
        ...state,
        planModal: action.payload
      };
    },
    updateProductList: (state, action) => {
      return {
        ...state,
        productList: action.payload
      };
    },
    updatePlan: (state, action) => {
      return {
        ...state,
        plan: action.payload
      };
    },
    updateTheme: (state, action) => {
      return {
        ...state,
        theme: action.payload
      };
    },
    updatePlanPermissions: (state, action) => {
      return {
        ...state,
        planPermissions: action.payload
      };
    },
    updateExtraParam: (state, action) => {
      return {
        ...state,
        extraParam: action.payload
      };
    },
    updateRmDetails: (state, action) => {
      return {
        ...state,
        rmDetails: action.payload
      };
    },
    updateNavigationTourGuide: (state, action) => {
      return {
        ...state,
        navigationTourGuidetails: action.payload
      };
    }
  }
});

// Actions
export const {
  updateCurrentUser,
  updateIsLoggedIn,
  updatePlanModal,
  updatePlan,
  updateTheme,
  updateProductList,
  updatePlanPermissions,
  updateExtraParam,
  updateRmDetails,
  updateNavigationTourGuide
} = userSlice.actions;

export default userSlice.reducer;
